import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { api } from '../lib/api';

interface BrandConfig {
    name: string;
    tagline: string;
    primary_color?: string;
    secondary_color?: string;
    accent_color?: string;
    logo_url?: string;
    bio?: string;
    features?: string[];
}

interface BrandContextType {
    config: BrandConfig | null;
    loading: boolean;
}

const BrandContext = createContext<BrandContextType>({ config: null, loading: true });

export const useBrand = () => useContext(BrandContext);

export function BrandProvider({ children }: { children: ReactNode }) {
    const [config, setConfig] = useState<BrandConfig | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchConfig() {
            try {
                const data = await api.getBrandConfig();
                setConfig(data);
            } catch (error) {
                console.error('Failed to load brand config:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchConfig();
    }, []);

    return (
        <BrandContext.Provider value={{ config, loading }}>
            {children}
        </BrandContext.Provider>
    );
}
